import axios from "axios";

/**
 * uploadToS3 - Upload a file to AWS S3 using a presigned URL
 * ------------------------------------------------------------
 * Performs a PUT request to the provided presigned URL with the file.
 *
 * @param {File} file - The file object to upload
 * @param {string} presignedUrl - The presigned S3 URL
 * @returns {Promise<boolean>} - Returns true if upload succeeds, false otherwise
 *
 * Usage:
 * const success = await uploadToS3(file, presignedUrl);
 * if (success) console.log("Upload completed!");
 */
export const uploadToS3 = async (file, presignedUrl) => {
  try {
    const response = await axios.put(presignedUrl, file, {
      headers: {
        "Content-Type": file.type,
      },
    });

    console.log("✅ Upload successful:", response.status);
    return true;
  } catch (error) {
    console.error("❌ Upload failed:", error);
    return false;
  }
};
